/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, November 2022
 * @format
 * @flow
 */

import { useState, useRef } from 'react';

const useAsyncState = value => {
  const ref = useRef(value);
  const [, forceRender] = useState(false);

  const updateState = newState => {
    ref.current = newState;
    forceRender(s => !s);
  };

  return [ref, updateState];
};

export default useAsyncState;
